import { Link, useRoute } from "wouter";
import BrandLockup from "@/components/BrandLockup";
import { useAuth } from "@/contexts/AuthContext";
import { getVoicePage } from "@/content/voicePages";
import AccountActions from "@/components/AccountActions";
import VoiceRecorder from "@/components/VoiceRecorder";

export default function VoicePage() {
  const [, params] = useRoute<{ page: string }>("/v/:page");
  const page = getVoicePage(params?.page);
  const { session, isLoading } = useAuth();

  if (!page) {
    return (
      <div className="paper-shell inner-shell">
        <header className="site-header"><BrandLockup /></header>
        <main className="callback-layout">
          <section className="callback-card">
            <p className="eyebrow">Voice page</p>
            <h1>We couldn’t<br />find that page<span className="title-period">.</span></h1>
            <Link href="/" className="primary-action">Return home <span aria-hidden="true">→</span></Link>
          </section>
        </main>
      </div>
    );
  }

  return (
    <div className="paper-shell inner-shell">
      <header className="site-header">
        <BrandLockup />
        {session && <AccountActions />}
      </header>

      <main className="voice-layout">
        <section className={`voice-prompt-card${session ? " voice-prompt-card-recording" : ""}`} aria-labelledby="voice-title">
          <p className="eyebrow"><span className="eyebrow-rule" /> {page.number} · {page.chapterTitle}</p>
          <h1 id="voice-title">{page.prompt}</h1>
          <p className="gentle-note">Take your time. There’s no wrong answer.</p>
          {isLoading ? (
            <div className="auth-status" role="status">Checking your sign-in…</div>
          ) : session ? (
            <VoiceRecorder userId={session.user.id} pageNumber={page.number} />
          ) : (
            <Link href={`/login?next=${encodeURIComponent(`/v/${page.number}`)}`} className="primary-action full-width">
              Sign in to record <span aria-hidden="true">→</span>
            </Link>
          )}
        </section>
      </main>

      <footer className="site-footer voice-page-footer">
        <div className="voice-footer-links">
          <Link href="/" className="back-link">← Home, Twice</Link>
          {session && <Link href="/library" className="back-link">My voice pages</Link>}
          <nav className="legal-footer-links" aria-label="Legal">
            <Link href="/privacy">Privacy Policy</Link>
            <Link href="/terms">Terms</Link>
          </nav>
        </div>
        <span>Published by Kwaderno &amp; Co.</span>
      </footer>
    </div>
  );
}
